<script>
import Home from '~icons/mdi/home';
import ActionButton from "../ActionButton.svelte";

</script>

<ActionButton href='/' outlink={false}>
  <Home />
  Home
</ActionButton>
